import UserManualMain from '@/components/UserManual/index'
const UserManual = () => {
    const element = (<UserManualMain />)
    return element
}
export default UserManual